export const adminRoute: string = 'admin';
export const changeRequestRoute: string = 'change-request';
export const createUserRoute: string = 'create';
export const editUserRoute: string = 'edit-user';
export const newRequestsRoute: string = 'new-requests';
export const newRequestRoute: string = 'new-request';
export const portalUsersRoute: string = 'portal-users';
export const portalUserRoute: string = 'portal-user';
